module.exports = __webpack_public_path__ + "assets/img/btn-view-1020ada2.png";